import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/vipps-logginn.svg")